import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=738732f6&"
import script from "./checkout.vue.ts?vue&type=script&lang=ts&"
export * from "./checkout.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports